@value tablet from "@shared/styles/breakpoints.module.css";

.root {
  width: 100%;
  max-width: var(--layout-content-max);
  margin: 0 auto;
}

.hero {
  padding: var(--space-page-top) var(--space-page) 0;
}

.headingRow {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: var(--space-project-gap);

  @media (max-width: tablet) {
    flex-direction: column;
    align-items: start;
  }
}

.title {
  font-family: var(--font-heading);
  font-size: var(--type-page);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text);
}

.intro {
  max-width: 43ch;
  font-size: var(--type-body);
  line-height: 1.6;
  color: var(--color-text-muted);
}

.collection {
  padding: var(--space-section-inset) var(--space-page) var(--space-project-bottom);
}

.grid {
  display: grid;
  gap: var(--space-section-gap);
  margin-top: var(--space-section-gap);
}

.contact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-32);
  padding: var(--space-section-inset) var(--space-page);
  background: var(--color-card);

  @media (max-width: tablet) {
    flex-direction: column;
    align-items: start;
  }
}

.contactTitle {
  margin-bottom: var(--space-12);
  font-family: var(--font-heading);
  font-size: var(--type-section);
  font-weight: 600;
  line-height: 1.25;
  text-transform: none;
  letter-spacing: normal;
  color: var(--color-text);
}

.contactText {
  max-width: 60ch;
  color: var(--color-text-muted);
  line-height: 1.6;
}

.contactLink {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: var(--layout-action-height);
  padding: var(--space-12) var(--space-20);
  border-radius: var(--radius-control);
  background: var(--color-primary);
  color: var(--color-cta-text-color);
  font-family: var(--font-body);
  font-size: var(--type-caption);
  font-weight: 700;
  text-transform: none;
  text-decoration: none;
  transition:
    filter var(--motion-fast) ease,
    transform var(--motion-fast) var(--motion-ease-out);

  @media (max-width: tablet) {
    align-self: flex-end;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      filter: brightness(1.08);
    }
  }

  &:active {
    transform: scale(0.98);
  }
}
